<template style="padding-left:100px;" id="excitare_field_validation">
  <section>
     <div class="excitare-container ml-5">
        <div class="d-flex w-100 m-auto p-3 justify-content-center flex-column exitare ml-5">
            <div class="card ml-5" style="width:110%">
                <div class="card-header"><h1>Excitare</h1></div>
                <div class="card-body">
                    <form>
                        <div class="mb-3" style="width:60%">
                            <label class="float-left"> First Name:</label>
                            <input type="text" v-model="Name" class="form-control name"  placeholder="First Name"  @keyup="alphaValidate(Name); spaceValidate(Name)" >
                            <span v-if="Name" v-show="isAlpha" style="color: red">{{errAlpha}}</span>
                            <span v-if="Name" v-show="isSpace" style="color: red">{{errSpace}}</span>
                       </div>
                        <div class="mb-3" style="width:60%">
                          <label class="float-left"> Corp Name:</label>
                          <input type="text" v-model="corpName" class="form-control name" placeholder="Corp Name" @keyup="alphaValidate(corpName); spaceValidate(corpName)">
                           <span v-if="corpName" v-show="isAlpha" style="color: red">{{errAlpha}}</span>
                          <span v-if="corpName" v-show="isSpace" style="color: red">{{errSpace}}</span>
                        </div>

                        <div class="mb-3" style="width:60%">
                            <label class="float left"> Salary Amount </label>
                            <input type="text" v-model="salaryAmount" class="form-control" >
                        </div>

                        <div class="mb-3" style="width:60%">
                            <label class="float left">UK Phone Number</label>
                             <input type="text" class="form-control" id="phoneNum" @keypress="onlyNumbers"
                             placeholder="phone number"  @keyup="phoneNumValidation(phoneNumber)"
                              maxlength= "10" v-model="phoneNumber"  required>
                            <span id="lblphoneNum" class="error">Phone Number should  start with 0</span>
                           </div>

                        <div class="row" style="width:60%">
                            <div class="col-md-4 mb-2">
                                <label class="float left">Title</label>
                                 <select v-model="title" @change="getTitleData()">
                                <option v-for="(wtc,index) in options" v-bind:key="index" >{{wtc[1].lov_field_value}}
                                 </option>
                                 </select>                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="float left">First name</label>
                                <input type="text" v-model="firstName" class="form-control name" placeholder="First Name"
                                    @keyup="alphaValidate(firstName); spaceValidate(firstName)" required>
                                <span v-if="firstName" v-show="isAlpha" style="color: red">{{errAlpha}}</span>
                                <span v-if="firstName" v-show="isSpace" style="color: red">{{errSpace}}</span>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="float left">Last name</label>
                                <input type="text" v-model="lastName" class="form-control name"  placeholder="Last Name"
                                   @keyup="alphaValidate(lastName); spaceValidate(lastName)" required>
                                <span v-if="lastName" v-show="isAlpha" style="color: red">{{errAlpha}}</span>
                                <span v-if="lastName" v-show="isSpace" style="color: red">{{errSpace}}</span>
                            </div>
                        </div>

                        <div class="row" style="width:60%">
                            <div class="col-md-4 mb-3">
                                <label>Date</label>
                               <input type="text" id="" @keypress="onlyNumbers" name="day" @input="dayValidate" v-model="day" ref="day"
                                  placeholder="DD" value="day" required maxlength="2">
                            </div>
                            <div class="col-md-4 mb-3">
                               <label>Month</label>
                               <input type="text" id="" class="form-control" @keypress="onlyNumbers" @input="monthValidate" name="month" v-model="month" ref="month"
                                  placeholder="MM" value="month" required maxlength="2">
                           </div>
                           <div class="col-md-4 mb-3">
                               <label>Year</label>
                               <input type="text" class="form-control" @keypress="onlyNumbers" name="year" @input="yearValidate" v-model="year" ref="year"
                                  placeholder="YYYY" value="" required maxlength="4">
                           </div>
                           <button type="button" class="btn btn-primary ml-3 mb-5" @click="dobValidate()" :disabled='(year.length!=4 || month.length==0 || day.length==0)'>Validate</button>
                           <span class="ml-3" v-show="isDayValid" style="color:red">{{errorDay}}</span>
                           <span class="ml-3" v-show="isMonthValid" style="color:red">{{errorMonth}}</span>
                           <span class="ml-3" v-show="isAgeValid" style="color:red">{{errorAge}}</span>
                        </div>

                     <div class="mb-3" style="width:60%">
                     <label class="float left"> Address </label>
                     <input type="text"
                            class="form-control name"
                            placeholder="Start typing your address..."
                            autocomplete="off"
                            v-model="address"
                            @focus="modal=true">
                    <div v-for="key in newAddress" v-bind:key="key.Text" @click="setAddress(key.Text)" >
                       <span class="result" v-if="newAddress && modal" >{{ key.Text }}</span>
                     </div>
                     </div>
                      <div class="mb-3" style="width:60%">
                        <label class="float left"> Employer Name </label>
                        <input type="text" v-model="employerName" class="form-control name" @keyup=" alphaNumValidate(employerName); spaceValidate(employerName) ">
                          <span v-if="employerName" v-show="isAlphaNum" style="color: red">{{errAlphaNum}}</span>
                          <span v-if="employerName" v-show="isSpace" style="color: red">{{errSpace}}</span>
                      </div>

                      <div class="row" style="width:65%">
                        <div class="col-md-6 mb-3">
                            <label class="float left">Bank Account Sort Code</label>
                            <input type="text" v-model="sortCode" class="form-control name"  placeholder="Sort Code"  required @keyup=" alphaNumValidate(sortCode); spaceValidate(sortCode) ">
<!--                            <span v-if="sortCode" v-show="isAlphaNum" style="color: red">{{errAlphaNum}}</span>
                            <span v-if="sortCode" v-show="isSpace" style="color: red">{{errSpace}}</span>-->
                        </div>
                        <div class="col-md-6 mb-3">
                          <label class="float left">Bank Account Number</label>
                          <input type="text" v-model="accountNumber" class="form-control name"  placeholder="Account Number">
                        </div>
                       <div>
                        <button type="button" class="btn btn-primary ml-3 mb-5" @click="bank_callback()">Verify</button>
                        <span class="ml-3" v-if="sortCode" style="color:green">{{bank_validate}}</span>
                       </div>

                        <div class="col-md-6 mb-3">
                            <label class="float left">Account Name</label>
                            <input type="text" class="form-control name" placeholder="Account Name"  @keyup="alphaValidate(accountName); spaceValidate(accountName)" required>
                            <span v-if="accountName" v-show="isAlpha" style="color: red">{{errAlpha}}</span>
                            <span v-if="accountName" v-show="isSpace" style="color: red">{{errSpace}}</span>
                        </div>
                      </div>

                      <div class="mb-3" style="width:60%">
                        <label class="float left"> Industry type </label>
                        <input type="text" v-model="industryType" class="form-control">
                      </div>

                      <div class="mb-3" style="width:60%">
                        <label class="float left"> Job Title </label>
                        <input type="text" v-model="jobTitle" class="form-control">
                      </div>
                    </form>
                </div>
            </div>
        </div>
     </div>
  </section>
</template>
<script>
import axios from 'axios'

export default {
        name: 'excitare_field_validation',

        data: function() {
            return {
              Name:null,
              title:'',
              firstName: null,
              lastName: null,
              corpName: null,
              salaryAmount: null,
              employerName: null,
              phoneNumber: null,
              address: null,
              sortCode: null,
              accountName: null,
              accountNumber:'',
              industryType: null,
              jobTitle: null,
              options: ['Mr','Mrs','Ms'],
              day: null,
              isDayValid: true,
              month: null,
              isMonthValid: true,
              year: '',
              isLeapYear: false,
              isAgeValid: true,
              errorAge: null,
              errorMonth: null,
              errorDay: null,
              isAlphaNum:null,
              isSpace:null,
              errAlphaNum:null,
              errSpace:null,
              isAlpha:null,
              errAlpha:null,
              modal: false,
              newAddress: [],
              newBanks: [],
              bnk:'',
              bank_validate:'',
            }
        },
        created: function () {
            this.dobValidate()
        },
        methods: {
            onlyNumbers(event) {
                let keyCode = event.keyCode ? event.keyCode : event.which;
                if (keyCode < 48 || keyCode > 57) {
                    event.preventDefault();
                }
            },
            dayValidate() {
                if(this.day> 31 && this.day.length> 1) {
                    this.errorDay= "DD between 1 to 31"
                    this.isDayValid= true
                } else{
                    this.isDayValid= false
                }
            },
            monthValidate() {
                    if(this.month> 12){
                        this.errorMonth= "MM between 1 to 12"
                        this.isMonthValid= true
                    } else{
                        this.isMonthValid= false
                    }
            },
            yearValidate() {
                if (this.year % 4 === 0) {
                      if (this.year % 100 === 0){
                         if (this.year % 400 == 0){
                            return this.isLeapYear= true; //29
                         } else {
                            return this.isLeapYear= false; //28
                         }
                      } else {
                         return this.isLeapYear= true; //29
                      }
                } else{
                    return this.isLeapYear= false //28;
                }
            },
            dobValidate() {
                this.day= this.day.padStart(2, "0")
                this.month= this.month.padStart(2, "0")
                const today = new Date()
                const validateFullDate = this.year+'/'+ this.month.padStart(2, "0")+'/'+ this.day.padStart(2, "0");
                var birthDate = new Date(validateFullDate);
                var age = today.getFullYear() - birthDate.getFullYear();
                var monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                      age--;
                }

                if(this.day>29 && this.month==2 && this.isLeapYear== true) {
                    this.errorMonth= 'Invalid Date, Please enter correct date'
                    this.isMonthValid= true
                }
                else if(this.day>28 && this.month==2 && this.isLeapYear== false) {
                  this.errorMonth= 'Invalid Date, Please enter correct date'
                  this.isMonthValid= true
                }
                else if(this.day>30 && (this.month==4 || this.month== 9 || this.month== 11 || this.month==6)) {
                    this.errorMonth= 'Invalid Date, Please enter correct date'
                    this.isMonthValid= true
                }else if(this.isMonthValid== false) {
                    if(this.year.length===4){
                        if(age<= 18 || age> 64){
                            this.errorAge= 'Age should be between 18 to 64 years'
                            this.isAgeValid= true
                        } else {
                            this.isAgeValid= false
                        }
                    }
                } else {
                  this.isMonthValid= false
                }


            },
            phoneNumValidation(){
              let phoneNum = document.getElementById("phoneNum");
              let lblphoneNum = document.getElementById("lblphoneNum")
              if(phoneNum.value!="0"){
                lblphoneNum .style.visibility = "visible";
                 return false;
              } else {
                lblphoneNum.style.visibility = "hidden";
               return true;
             }
           },
           alphaNumValidate(e) {
               //Regex for Valid Characters i.e. Alphabets and Numbers.
               var regex = /^[A-Za-z0-9'\s]+$/;

               //Validate TextBox value against the Regex.
               if (regex.test(e)) {
                  this.isAlphaNum=false
               }
               else {
                  this.isAlphaNum=true
                  this.errAlphaNum="Only Alphabets and Numbers allowed."
               }
           },
           spaceValidate(e) {
              //Regex for Valid Characters i.e. Alphabets and Numbers. allows only one white space
              var regex = /\s{2,}/g

              //Validate TextBox value against the Regex.
              if (regex.test(e)) {
                   this.isSpace=true
                   this.errSpace="Multiple spaces not allowed"
              }
              else {
                this.isSpace=false
              }
           },
           alphaValidate(e) {
              //Regex for Valid Characters i.e. Alphabets and  allows only one white space
              var regex = /^[A-Za-z'\s]+$/;

              //Validate TextBox value against the Regex.
              if (regex.test(e)) {
                  this.isAlpha=false
              }
              else {
                 this.isAlpha=true
                 this.errAlpha="Allow only alphabets"
              }
          },
          getTitleData()
            {
              axios.post('/api/fetchDataWithParam/SQL773/Any',{}).then(res => {
                       let data = res.data;
                       let result =data.rowsData;
                       this.options=data.rowsData;
                       console.log("options",result)

                     }, err => {
                       console.log('Error Fetching data', err)
                     })
            },
            setAddress(address){
                        this.address = address;
                        this.modal = false;
                        console.log("sss",address,this.newAddress)
                      },

             postAddress: function (callback) {
                      var Key = "BN89-KB86-PJ46-KP55",//"BJ23-BX33-AH88-FB69",
                            Text=this.address,//"wr5 3da",
                            IsMiddleware=false,
                            Container=this.address,//"GB|RM|ENG|3DA-WR5",
                            Origin="",//"52.182,-2.222",
                            Countries="",//"GB,USA,CA",
                            Limit="10",
                            Language="",
                            Bias="",
                            Filters="",
                            GeoFence="";
                        // IsMiddleware = false, Origin = "",Countries = "GBR,USA", Limit = "10", Language = "en-gb"
                        var url = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';
                        var params = '';
                        params += "&Key=" + encodeURIComponent(Key)
            ;
                        params += "&Text=" + encodeURIComponent(Text);
                        params += "&IsMiddleware=" + encodeURIComponent(IsMiddleware);
                        params += "&Container=" + encodeURIComponent(Container);
                        params += "&Origin=" + encodeURIComponent(Origin);
                        params += "&Countries=" + encodeURIComponent(Countries);
                        params += "&Limit=" + encodeURIComponent(Limit);
                        params += "&Language=" + encodeURIComponent(Language);
                        params += "&Bias=" + encodeURIComponent(Bias);
                        params += "&Filters=" + encodeURIComponent(Filters);
                        params += "&GeoFence=" + encodeURIComponent(GeoFence);

                        var http = new XMLHttpRequest();
                        http.open('POST', url, true);
                        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                        http.onreadystatechange = function () {
                          if (http.readyState == 4 && http.status == 200) {
                            var response = JSON.parse(http.responseText);
                            // Test for an error
                            if (response.Items.length == 1 && typeof (response.Items[0].Error) != "undefined") {
                              // Show the error message
                              alert(response.Items[0].Description);
                            } else {
                              // Check if there were any items found
                              if (response.Items.length == 0)
                                alert("Sorry, there were no results");
                              else {
                                if (typeof callback === "function") {
                                  // apply() sets the meaning of "this" in the callback
                                  var resp  = JSON.parse(http.responseText);
                                  callback(resp);
                                }
                                // PUT YOUR CODE HERE
                                //FYI: The output is an array of key value pairs (e.g. response.Items[0].Id), the keys being:
                                //Id
                                //Type
                                //Text
                                //Highlight
                                //Description
                              }
                            }
                          }
                        }
                        http.send(params);
                      },
                      getJobtitle()
                      {

                      },
          bankVerification:function (callback){
            var url = 'https://api.addressy.com/BankAccountValidation/Batch/Validate/v1.00/json3.ws';
            // https://api.addressy.com/BankAccountValidation/Batch/Validate/v1.00/csv.ws?Key=HJ63-RY11-XA51-NP92&AccountNumbers=01375709,23456789&SortCodes=30-18-25,22-33-44

            /* else if(this.account =='')
               alert("Please Enter Account Number")*/
            var params = '';
            var Key = 'HJ63-RY11-XA51-NP92',AccountNumbers=this.accountNumber/*'01375709'*/,SortCodes=this.sortCode;//'30-18-25';
            params += "&Key=" + encodeURIComponent(Key);
            params += "&AccountNumbers=" + encodeURIComponent(AccountNumbers);
            params += "&SortCodes=" + encodeURIComponent(SortCodes);

            if(SortCodes == '' || SortCodes==null)
              alert("Please enter Bank code")

            var http = new XMLHttpRequest();
            http.open('POST', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            if(SortCodes) {
              http.onreadystatechange = function () {
                if (http.readyState == 4 && http.status == 200) {
                  var response = JSON.parse(http.responseText);
                  // Test for an error
                  if (response.Items.length == 1 && typeof (response.Items[0].Error) != "undefined") {
                    // Show the error message
                    alert(response.Items[0].Description);
                  } else {
                    // Check if there were any items found
                    if (response.Items.length == 0)
                      alert("Sorry, there were no results");
                    else {
                      // PUT YOUR CODE HERE
                      console.log("bank:", response.Items[0])
                      if (typeof callback === "function") {
                        // apply() sets the meaning of "this" in the callback
                        var resp = JSON.parse(http.responseText);
                        callback(resp);
                        alert(response.Items[0].IsCorrect);

                      }
                      //FYI: The output is an array of key value pairs (e.g. response.Items[0].OriginalAccountNumber), the keys being:
                      //OriginalAccountNumber
                      //OriginalSortCode
                      //IsCorrect
                      //IsDirectDebitCapable
                      //StatusInformation
                      //CorrectedSortCode
                      //CorrectedAccountNumber
                      //IBAN
                      //Bank
                      //BankBIC
                      //Branch
                      //BranchBIC
                      //ContactAddressLine1
                      //ContactAddressLine2
                      //ContactPostTown
                      //ContactPostcode
                      //ContactPhone
                      //ContactFax
                    }
                  }
                }
              }
            }
            http.send(params);
            },
          bank_callback: function() {
            this.bankVerification(function (resp) {
              console.log("bank2:", resp);
              self.newBanks = resp.Items.filter(function (item) {
                if(item.IsCorrect==true){
                  alert("valid");
                  this.bank_validate = item.IsCorrect;
                  console.log("valid",item.IsCorrect)
                }
                else  alert("Invalid");


                return item.Bank.toLowerCase().includes(this.sortCode) && this.sortCode != "";
              });
            });

          }
        },
        watch:{
                address(val){
                  var self=this;
                  this.postAddress(function (resp) {
                    console.log("Welcom1:",resp);
                    self.newAddress = resp.Items.filter(function(item)  {
                      return item.Text.toLowerCase().startsWith(val.toLowerCase());
                    });
                  });
                },
              /*  bnk(){
                  var self=this;
                  this.bankVerification(function (resp) {
                    console.log("bank2:",resp);
                    self.newBanks = resp.Items.filter(function(item)  {
                      return item.Bank.toLowerCase().includes(this.sortCode) && this.sortCode != "";
                    });
                  });
                },*/
                deep:true,
                immediate:true
              },
    }
</script>
<style>
    .excitare-container {
        display: flex;
        width: 100vh;
        height: 75vh;
        justify-content: center;
        align-content: center;
        align-items: center;
        align-self: center;
        padding-top: 50px;
    }

    .excitare { box-shadow: 1px 2px 2px 3px #a7aeaa; }
    .name { text-transform:capitalize; }
    .btn.btn[disabled] { color: black; }
</style>